<!-- {{modelInputCheck.checked}} -->
<input type="checkbox" id="my_modal_6" class="modal-toggle" [checked]="modelInputCheck" />
<div class="modal" role="dialog">
    <div class="modal-box p-0 max-w-sm min-h-[10rem] hide-scrollbar">
        @defer (on timer(500ms)) {
        <div class="p-5">
            <span class="w-10 h-10 flex items-center justify-center rounded-md bg-red-100 text-red-600">
                <i class="ri-delete-bin-4-line"></i>
            </span>
            <h3 class="text-lg font-bold mt-3">{{title}}</h3>
            <p class="mt-2 text-sm text-zinc-500">{{message}}</p>
        </div>
        <div class="grid grid-cols-2">
            <button class="btn w-full rounded-none " (click)="onCancel()">Cancel</button>
            <button class="btn w-full rounded-none btn-error" (click)="onConfirm() ">Delete</button>
        </div>
        }
        @placeholder {
        <div class="w-full h-[10rem] flex justify-center items-center">
            <span class="loading loading-spinner text-primary"></span>
        </div>
        }




    </div>
</div>